import { createUrl } from '@vfde-sails/utils';
import { Domain, Endpoint, QueryNames } from '../enum';

export const getOptionPageUrl = (id: string, tvConnectId?: string) =>
    createUrl(Domain.ZH, Endpoint.OPTION_PAGE, {
        [QueryNames.BASKET]: tvConnectId ? [id, tvConnectId] : id,
    });

export const getMeinVodafonePageUrl = (targetUrl = location.href) =>
    createUrl(Domain.VF, Endpoint.LOGIN, {
        [QueryNames.AFTER_LOGIN_TARGET]: targetUrl,
    });
